import React from 'react';
import { motion } from 'framer-motion';
export function ProblemSection() {
  return <section className="py-24 md:py-32 px-6 bg-pond-dark relative overflow-hidden" data-id="element-158">
      {/* Subtle gradient line */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-pond-blue/30 to-transparent" data-id="element-159" />

      <div className="max-w-3xl mx-auto text-center" data-id="element-160">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} data-id="element-161">
          <h2 className="text-3xl md:text-5xl font-serif text-pond-cream mb-10 leading-relaxed" data-id="element-162">
            You already know the feeling.
          </h2>

          <div className="space-y-6 text-lg md:text-xl text-pond-cream-muted font-light leading-relaxed" data-id="element-163">
            <p data-id="element-164">
              Another evening lost to scrolling. Reaching for your phone during
              dinner. The exhaustion of being always on.
            </p>
            <p data-id="element-165">
              Your phone promised connection. Instead, it scattered your
              attention into a thousand pieces.
            </p>
          </div>

          <div className="my-16 flex justify-center" data-id="element-166">
            <motion.div className="w-24 h-1 bg-gradient-to-r from-pond-blue to-pond-lavender rounded-full" initial={{
            scaleX: 0
          }} whileInView={{
            scaleX: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8,
            delay: 0.3
          }} data-id="element-167" />
          </div>

          <div className="space-y-4" data-id="element-168">
            <h3 className="text-3xl md:text-4xl font-serif gradient-text" data-id="element-169">
              Pond is different.
            </h3>
            <p className="text-lg text-pond-cream-muted font-light max-w-xl mx-auto" data-id="element-170">
              A gentle app blocker that helps you reclaim your time. Not through
              guilt or gamification, but through quiet intention.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}